// Module
var code = "<div class=\"meta-info-status-body\"></div>";
// Exports
export default code;